import { UtilisateurEntity } from "./Entities/UtilisateurEntity.tsx";
import { useAppContext } from "./components/App/AppProvider.tsx";

export const ADMINISTRATEUR = "ADMINISTRATEUR";
export const PROCHE = "PROCHE";
export const PROCHE_BD = "PROCHE_BD";
export const PROCHE_CAPSULES_VIDEO = "PROCHE_CAPSULES_VIDEO";
export const PROCHE_FIN_DE_VIE = "PROCHE_FIN_DE_VIE";
export const PROCHE_REALITE_VIRTUELLE = "PROCHE_REALITE_VIRTUELLE";
export const PROCHE_SOIGNANT = "PROCHE_SOIGNANT";

export const Authorization = (
  { Component, roles, isPublic = false }: AuthorizationEntity,
  props: any[],
) => {
  const { user }: { user: UtilisateurEntity } = useAppContext();

  if (isPublic || (user && isAuthorized(user, roles ?? []))) {
    return <Component {...props} />;
  }

  return <Forbidden />;
};

type AuthorizationEntity = {
  Component: any;
  roles?: string[];
  isPublic?: boolean;
};

function isAuthorized(user: UtilisateurEntity, roles: string[]) {
  return roles.some((role) => hasDroit(user, role));
}

function hasDroit(user: UtilisateurEntity, droit: string) {
  switch (droit) {
    case ADMINISTRATEUR:
      return user.isAdministrateur;
    case PROCHE:
      return user.isProche;
    case PROCHE_BD:
      return user.isProcheBd;
    case PROCHE_CAPSULES_VIDEO:
      return user.isProcheCapsulesVideo;
    case PROCHE_FIN_DE_VIE:
      return user.isProcheFinDeVie;
    case PROCHE_REALITE_VIRTUELLE:
      return user.isProcheRealiteVirtuelle;
    case PROCHE_SOIGNANT:
      return user.isProcheSoignant;
    default:
      return false;
  }
}

export function useDroitsUser() {
  const { user }: { user: UtilisateurEntity } = useAppContext();

  return {
    isAdministrateur: user?.isAdministrateur,
    isProche: user?.isProche,
    isProcheBd: user?.isProcheBd,
    isProcheCapsulesVideo: user?.isProcheCapsulesVideo,
    isProcheFinDeVie: user?.isProcheFinDeVie,
    isProcheRealiteVirtuelle: user?.isProcheRealiteVirtuelle,
    isProcheSoignant: user?.isProcheSoignant,
  };
}

const Forbidden = () => {
  return <div>Vous n&apos;avez pas le droit d&apos;accéder à cette page</div>;
};
